import { colors, colorSystem } from '@/styles/theme'
import { HStack, VStack } from '@musinsa/mwms-ds'
import styled from 'styled-components'
import Text from '@/components/content/Text'
import { CapaItem } from './capacity/CapaItem'
import { useGetCapacityDaySummary } from '@/services/capacity/useCapacityQueries'
import { BaseCell } from './shared/BaseCell'
import { useGetTimeSlots } from '../hooks/useGetTimeSlots'
import { useCutOffDate } from '../hooks/useCutOffDate'
import { useRef } from 'react'
import { CutOffRow } from './cut-off/CutOffRow'
import { useGetCutOffWarehouses } from '@/services/warehouse/useWareHouseQueries'
import { MENU_CODE } from '../constants'

export const CELL_WIDTH = 200

export function OutboundTable() {
  const { cutOffDate } = useCutOffDate()

  const { data: sortedCutOffWarehouses } = useGetCutOffWarehouses()

  const { data: capaSummaryData } = useGetCapacityDaySummary({ date: cutOffDate }, MENU_CODE)

  const timeSlots = useGetTimeSlots()

  const scrollContainerRef = useRef<HTMLDivElement>(null)

  return (
    <TableWrap ref={scrollContainerRef}>
      {/* 출고케파 */}
      <CapaWrap>
        <CapaLeftWrap style={{ minWidth: CELL_WIDTH }}>
          <EmptyCell />
          <HStack style={{ height: 96 }}>
            <LabelCell style={{ borderBottom: 'none' }}>
              <Text kind="Body_12_regular">케파 현황</Text>
              <Text kind="Body_12_regular" color={colorSystem.text.common.tertiary}>
                *전체 화주사 기준
              </Text>
            </LabelCell>
            <VStack style={{ flex: 1 }}>
              <CapaTypeCell>
                <Text kind="Body_12_regular">B2C</Text>
              </CapaTypeCell>
              <CapaTypeCell>
                <Text kind="Body_12_regular">B2B</Text>
              </CapaTypeCell>
            </VStack>
          </HStack>
        </CapaLeftWrap>

        {sortedCutOffWarehouses?.map(({ warehouseCode, warehouseName }) => (
          <CapaItem
            key={warehouseCode}
            warehouseCode={warehouseCode}
            warehouseName={warehouseName}
            capacities={capaSummaryData?.warehouses?.find((w) => w.warehouseCode === warehouseCode)?.capacities ?? []}
          />
        ))}
      </CapaWrap>
      {/* 출고케파 end */}

      {/* 컷오프 */}
      {timeSlots
        ?.filter((timeRow) => timeRow.schedules.some((schedule) => schedule.centerSchedules.length > 0))
        .map((timeRow) => (
          <CutOffRow data={timeRow} scrollContainerRef={scrollContainerRef} key={timeRow.time} warehouses={sortedCutOffWarehouses ?? []} />
        ))}
      {/* 컷오프 end */}
    </TableWrap>
  )
}

const TableWrap = styled.div`
  width: 100%;
  margin-top: 16px;
  border-top: 1.5px solid ${colors.black};
  overflow: auto;
`

const CapaWrap = styled.div`
  min-width: fit-content;
  border-bottom: 1px solid ${colorSystem.text.common.secondary};
  background-color: ${colors.white};
  z-index: 99;

  display: flex;
  position: sticky;
  top: 0;
`

const CapaLeftWrap = styled(VStack)`
  background-color: ${colors.white};
  z-index: 9;

  position: sticky;
  left: 0;
`

const EmptyCell = styled(BaseCell)`
  height: 44px;
  border-bottom: 1px solid ${colors.gray400};
`

const LabelCell = styled(BaseCell)`
  width: 120px;

  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`

const CapaTypeCell = styled(BaseCell)`
  flex: 1;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }
`
